import jQuery from 'jquery';
(function ($) {
    function DynamicModal(
        modalElementId,
        title,
        text,
        noBtnName = 'Close',
        yesBtnName = '',
        yesBtnAction = () => {}
    ) {
        let existingElement = document.getElementById(modalElementId);
        $(existingElement).remove();
        var wrap = _buildModal(modalElementId, title, text, noBtnName, yesBtnName, yesBtnAction);
        document.body.append(wrap);
        this.modalId = modalElementId;
        $('#' + this.modalId).modal('hide');
        this.show = function () {
            $('#' + this.modalId).modal('show');
        };
    }

    function _buildModal(modalElementId, title, text, noBtnName, yesBtnName, yesBtnFunc) {
        var modal = document.createElement('div');
        modal.setAttribute('class', 'modal fade dynamic-modal');
        modal.setAttribute('tabindex', '-1');
        modal.setAttribute('id', modalElementId);
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-labelledby', 'modalLabel');
        modal.setAttribute('aria-hidden', 'true');
        var modDialog = document.createElement('div');
        modDialog.setAttribute('class', 'modal-dialog modal-lg');
        modDialog.setAttribute('role', 'document');
        var modContent = document.createElement('div');
        modContent.setAttribute('class', 'modal-content');
        var header = _buildModalHeader(title);
        modContent.append(header);
        var body = document.createElement('div');
        body.setAttribute('class', 'modal-body');
        body.innerHTML = text;
        modContent.append(body);
        var footer = _buildModalFooter(noBtnName, yesBtnName, yesBtnFunc);
        modContent.append(footer);
        modDialog.append(modContent);
        modal.append(modDialog);
        return modal;
    }

    function _buildModalHeader(text) {
        var header = document.createElement('div');
        header.setAttribute('class', 'modal-header');
        header.setAttribute('style', 'border-bottom: none;');

        var title = document.createElement('h5');
        title.setAttribute('class', 'modal-title');
        title.setAttribute('id', 'modalLabel');
        title.innerText = text;

        var closeBtn = document.createElement('button');
        closeBtn.setAttribute('class', 'btn-close close');
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.addEventListener('click', _closeModal);

        header.append(title);
        header.append(closeBtn);
        return header;
    }

    function _buildModalFooter(noBtnName, yesBtnName, yesBtnFunc) {
        var footer = document.createElement('div');
        footer.setAttribute('class', 'modal-footer');
        footer.setAttribute('style', 'border-top: none;');

        var noBtn = document.createElement('button');
        noBtn.setAttribute('type', 'button');
        noBtn.setAttribute('class', 'btn btn-secondary');
        noBtn.innerText = noBtnName;
        noBtn.addEventListener('click', _closeModal);
        footer.append(noBtn);

        if (yesBtnName && yesBtnFunc) {
            var yesBtn = document.createElement('button');
            yesBtn.setAttribute('type', 'button');
            yesBtn.setAttribute('class', 'btn btn-primary');
            yesBtn.innerText = yesBtnName;
            yesBtn.addEventListener('click', yesBtnFunc);
            footer.append(yesBtn);
        }
        return footer;
    }
    function _closeModal(element) {
        $(this).closest('.modal').modal('hide');
    }
    window.DynamicModal = DynamicModal;
})(jQuery);
